// Swym Custom Wishlist Script
//
// Renders the wishlist page cards client-side from Swym data, using the theme's
// own product-block markup so cards inherit the collection-grid styling
// (assets/styles.css.liquid). Grid columns, image shape and crop are read from
// data-* attributes on #wishlist-items-container (set in sections/wishlist.liquid)
// so they follow the theme's product-thumbnail settings instead of being
// hardcoded here. The wishlist-specific styling lives in that section's
// {% stylesheet %} block.
//
// Note: the `lazyloaded` class on the image is intentional. lazysizes does not
// process markup injected via innerHTML after page load, so we mark images as
// loaded and point src straight at the Swym image URL.

// Map the theme's image-shape setting to an aspect ratio (width / height).
// Shapes without a fixed ratio (natural/shortest/tallest) fall back to portrait-45.
var IMAGE_SHAPE_RATIOS = {
	'portrait-23': 0.67,
	'portrait-45': 0.8,
	'square': 1,
	'landscape-54': 1.25,
	'landscape-32': 1.5
};

function getWishlistConfig(container) {
	var shape = container.getAttribute('data-image-shape') || 'portrait-45';
	var ratio = IMAGE_SHAPE_RATIOS[shape] || IMAGE_SHAPE_RATIOS['portrait-45'];
	return {
		perRow: container.getAttribute('data-per-row') || '5',
		perRowMob: container.getAttribute('data-per-row-mob') || '2',
		shape: shape,
		padTop: (100 / ratio).toFixed(2) + '%',
		coverClass: container.getAttribute('data-image-crop') === 'true' ? 'cover' : ''
	};
}

function buildWishlistMarkup(cfg) {
	return `<div class="collection-listing">
   <div class="product-list product-list--per-row-${cfg.perRow} product-list--per-row-mob-${cfg.perRowMob} product-list--image-shape-${cfg.shape}" style="--wishlist-img-pad:${cfg.padTop}">
   {{#products}}
   <div class="product-block" data-product-id="{{empi}}">
     <div class="block-inner">
       <div class="block-inner-inner">
         <div class="image-cont">
           <div class="image-label-wrap">
             <a class="product-link" href="{{du}}" aria-label="{{dt}}" tabindex="-1">
               <div>
                 <div class="product-block__image product-block__image--primary product-block__image--active">
                   <div class="rimage-outer-wrapper">
                     <div class="rimage-wrapper lazyload--placeholder" style="padding-top:var(--wishlist-img-pad,125%)">
                       <img class="rimage__image ${cfg.coverClass} lazyloaded" src="{{iu}}" alt="{{dt}}">
                     </div>
                   </div>
                 </div>
               </div>
             </a>
             <button type="button" aria-label="Remove {{dt}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-remove-product-btn swym-delete-btn">
               <span class="swym-icon close-btn"></span>
             </button>
           </div>
         </div>
         <div class="product-info">
           <div class="inner">
             <div class="innerer">
               <a class="product-link" href="{{du}}">
                 <div class="product-block__title">{{dt}}</div>
                 <div class="product-block__price-wrapper product-block__price-wrapper--price-only">
                   <div class="product-price product-block__price">
                     <span class="product-price__item product-price__amount theme-money">{{cu}}{{pr}}</span>
                   </div>
                 </div>
               </a>
               <button type="button" data-state-cart="{{#isInCart}}swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" class="swym-custom-add-to-cart-btn button button--large product-form__add-button">
                 {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
               </button>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
   {{/products}}
   </div>
</div>`;
}

// Reduce a full Swym product URL to a storefront-relative path so links work on
// any domain (production, custom domain, dev/preview) without hardcoding hosts.
function toRelativeUrl(url) {
	try {
		var parsed = new URL(url, window.location.origin);
		return parsed.pathname + parsed.search;
	} catch (err) {
		return url;
	}
}

// Clean OOZOO product titles: drop the brand word and a trailing model/SKU code
// (e.g. "OOZOO ... - C10629" or "... - SG004-TB"), then capitalise.
function cleanWishlistTitle(title) {
	var cleaned = (title || '')
		.replace(/\bOOZOO\b/gi, '')
		.replace(/\s*-\s*[A-Z0-9]+(?:-[A-Z0-9]+)*\s*$/, '')
		.replace(/\s+/g, ' ')
		.trim();
	if (!cleaned.length) {
		return cleaned;
	}
	return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}

function onAddToCartClick(e) {
	e.preventDefault();
	var button = e.currentTarget;
	var productId = button.getAttribute("data-product-id");
	var variantId = button.getAttribute("data-variant-id");
	var du = button.getAttribute("data-product-url");
	button.innerHTML = "Adding..";
	button.disabled = true;
	window._swat.replayAddToCart({
		empi: productId,
		du: du
	}, variantId, function(c) {
		button.innerHTML = "Added to Cart";
		button.setAttribute("data-state-cart", "swym-added");
		button.disabled = false;
		if (window.theme && typeof window.theme.dispatchProductAdded === 'function') {
			var productBlock = button.closest('.product-block');
			var productTitle = productBlock ? productBlock.querySelector('.product-block__title') : null;
			var productImage = productBlock ? productBlock.querySelector('.rimage__image') : null;
			window.theme.dispatchProductAdded({
				product_id: productId,
				variant_id: variantId,
				product_title: productTitle ? productTitle.textContent.trim() : '',
				image: productImage ? productImage.currentSrc || productImage.src : '',
				url: du
			}, {
				preferredVariantId: variantId,
				source: 'wishlist'
			});
		}
		document.dispatchEvent(new CustomEvent('theme:cartchanged', { bubbles: true }));
	}, function(error) {
		console.log(error);
		button.innerHTML = "Add to cart";
		button.disabled = false;
	});
}

function onRemoveBtnClick(e) {
	e.preventDefault();
	var epi = +e.currentTarget.getAttribute("data-variant-id");
	var empi = +e.currentTarget.getAttribute("data-product-id");
	window._swat.fetch(function(products) {
		products.forEach(function(product) {
			if (epi && empi && product.epi == epi && product.empi == empi){
				window._swat.removeFromWishList(product, function() {
					swymRenderWishlist(window._swat);
					if (typeof renderWishlistCounter === 'function') {
						renderWishlistCounter(window._swat);
					}
				});
			}
		});
	})
}

function swymRenderWishlist(swat) {
	swat.fetch(function(products) {
		var container = document.getElementById("wishlist-items-container");
		if (!container) {
			console.log("Wishlist page container not found");
			return;
		}
		var cfg = getWishlistConfig(container);
		var formattedWishlistedProducts = products.map(function(p) {
			p = SwymUtils.formatProductPrice(p);
			p.dt = cleanWishlistTitle(p.dt);
			p.du = toRelativeUrl(p.du);
			p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
			return p;
		});
		var wishlistSection = container.closest('[data-section-type="wishlist"]');
		var isCartPage = window.location.pathname.includes('/cart');
		var cartPageDiv = document.getElementById('cart-page-wishlist-info');
		var hasWishlistProducts = formattedWishlistedProducts.length > 0;

		if (wishlistSection) {
			wishlistSection.hidden = isCartPage && !hasWishlistProducts;
		}
		if (cartPageDiv) {
			cartPageDiv.hidden = !hasWishlistProducts;
		}

		container.innerHTML = SwymUtils.renderTemplateString(buildWishlistMarkup(cfg), {
			products: formattedWishlistedProducts
		});
		attachClickListeners();
	});
}

function attachClickListeners() {
	var addToCartButtons = document.querySelectorAll(".swym-custom-add-to-cart-btn");
	var removeBtns = document.querySelectorAll(".swym-remove-product-btn");
	for (var i = 0; i < addToCartButtons.length; i++) {
		addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
	}
	for (var k = 0; k < removeBtns.length; k++) {
		removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
	}
}

if (!window.SwymCallbacks) {
	window.SwymCallbacks = [];
}
// Guard against the section appearing more than once (which would load this
// script twice and register the render callback multiple times).
if (!window.__oozooWishlistInitialised) {
	window.__oozooWishlistInitialised = true;
	window.SwymCallbacks.push(swymRenderWishlist);
}
